import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { PARK_DOCUMENT_LINE_ITEM } from "./apiRoutes";

const mutateDeleteLineItemById = async ({ id }: { id: string }) => {
  return await axiosAuth.delete(`${PARK_DOCUMENT_LINE_ITEM}/${id}`);
};

const useDeleteLineItemByIdMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateDeleteLineItemById,
    ...queryParams,
  });

export default useDeleteLineItemByIdMutation;
